export default "__VITE_ASSET__1b1aFFAR__"